export default "__VITE_ASSET__DQCcrt5r__"